import { Model } from 'modules/core/lib/mobx-rest'

export interface IStats {
  has_drafts: boolean
  has_drafts_without_conflict: boolean
  shift_conflicts: IShiftConflict[]
}

export interface IShiftConflict {
  id: number
  employee_id: number
  start_at: string
  conflicting_shifts_ids: number[]
  conflicting_leaves_ids: number[]
  conflicting_rest_days_ids: number[]
}

class Stats extends Model<IStats> {
  static urlRoot() {
    return '/shift_management/stats'
  }
}

export default Stats
